/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Connect_Status_Getting_File_ContextInputs */



/**
* | output |
* | --- |
* | "Getting file context from Ateliere..." |
*
* @param {Ateliere_Connect_Status_Getting_File_ContextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_status_getting_file_context = /** @type {((inputs?: Ateliere_Connect_Status_Getting_File_ContextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Status_Getting_File_ContextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Récupération du contexte de fichier depuis Ateliere...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dateikontext von Ateliere abrufen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ottenere il contesto del file da Ateliere...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Получение контекста файла из Ateliere...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Obteniendo el contexto del archivo de Ateliere...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("从 Atelier 获取文件上下文...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Ateliere からファイル コンテキストを取得しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एटेलियर से फ़ाइल संदर्भ प्राप्त किया जा रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Obtendo o contexto do arquivo do Ateliere...")
	return /** @type {LocalizedString} */ ("Getting file context from Ateliere...")
});